import { render } from "./add-contractual.vue?vue&type=template&id=10866643&scoped=true"
import script from "./add-contractual.vue?vue&type=script&lang=js"
export * from "./add-contractual.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./add-contractual.vue?vue&type=style&index=1&id=10866643&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10866643"]])

export default __exports__